import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import isEmpty from 'lodash/isEmpty';
import { getIsOrderBarberItemsEmpty, getNotSelectedBarbers } from '../../order/selectors';
import { addBarber } from '../../order/actions';
import { getIsRentalShop } from '../../../auth/selectors';
import AddAnotherBarber from '../components/AddAnotherBarber';
import withToggle from '../../../common/hoc/withToggle';
import * as barberSelectors from '../../../main/barbers/selector';
import { getSaleSource } from '../../source/selectors';

export default compose(
  withToggle(),
  connect(
    (state) => {
      const barbers = getNotSelectedBarbers(state, barberSelectors.getAll(state));
      return {
        barbers,
        shouldShowAddBarber: !getIsRentalShop(state) && !getIsOrderBarberItemsEmpty(state) && !isEmpty(barbers),
        canAddAnotherBarber: getSaleSource(state) !== 'appointment_product',
      };
    },
    { addBarber }
  ),
  withHandlers({
    addBarber: props => id => () => {
      props.addBarber(id);
      props.off();
    },
  }),
  branch(
    props => !props.shouldShowAddBarber,
    renderNothing,
  )
)(AddAnotherBarber);
